import * as Yup from 'yup';

export const transferSchema = ({ originPondCycle }) => Yup.object({
  average_weight: Yup.number().required('Campo Obrigatório'),
  sample_size: Yup.number().required('Campo Obrigatório'),
  origin: Yup.number().required('Campo Obrigatório'),
  destiny: Yup.number().required('Campo Obrigatório').nullable(),
  old: Yup.string().max(3, 'Limite ultrapassado (3 números)').required('Campo Obrigatório'),
  quantity: Yup.string()
    .min(0, 'Precisa ser acima de 0')
    .max(
      9,
      'O valor está acima da quantidade de animais existentes',
    )
    .test(
      'max-value',
      'O valor não pode ser maior que 100.000.000',
      (value) => {
        if (!value) return true;
        const numericValue = Number(value.replace(/\./g, ''));
        return numericValue <= 100000000;
      },
    )
    .test(
      'max-quantity',
      `Valor precisa ser abaixo da capacidade restante de animais (${originPondCycle && originPondCycle.population}).`,
      (value) => {
        if (!value || !originPondCycle) return true;
        const numericValue = Number(value);
        return numericValue <= (originPondCycle && originPondCycle.population);
      },
    )
    .required('Campo Obrigatório'),
});
